import { render, staticRenderFns } from "./GeorestrictionProfilesManager.vue?vue&type=template&id=41b23c1a&scoped=true"
import script from "./GeorestrictionProfilesManager.vue?vue&type=script&lang=js"
export * from "./GeorestrictionProfilesManager.vue?vue&type=script&lang=js"
import style0 from "./GeorestrictionProfilesManager.vue?vue&type=style&index=0&id=41b23c1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b23c1a",
  null
  
)

export default component.exports